var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"connectors"},[_c('SVGConnector',{ref:"connector",on:{"shader":function (v) { _vm.shader = v }}})],1),_vm._v(" "),_c('div',{ref:"canvas-area",staticClass:"canvas-area"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0111ba9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/shader-svg/ShaderSVG.vue
// module id = 504
// module chunks = 2